<template>
  <div class="faqs faqs-header answer">
    <Breadcrumbs></Breadcrumbs>
    <div v-if="topics.length">
      <SessionContent :session="session"></SessionContent>
      <b-row class="justify-content-md-center boxes">
        <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
          <FaqSearchBox></FaqSearchBox>
        </b-col>
      </b-row>
      <div class="home-icons">
        <div class="inputs">
          <div v-if="isIconButtons" class="home-icons">
            <b-row class="justify-content-sm-center boxes icon-buttons ">
              <b-col cols="12" sm="auto" v-for="topic in topics" :key="'topic-' + topic.id" @click="selectTopic(topic.id)" class="choice">
                <div class="box hide-on-phone">
                  <img :src="topic.icon.file" alt="" block variant="primary"/>
                  <h2><div>{{topic.title}}</div></h2>
                </div>
                <b-button block
                          class="d-sm-none btn btn-default btn-session gutters mob-home-btn"
                          variant="primary">
                  <img :src="topic.icon.file" alt="" block variant="primary" class="mob-home-btn-icon"/>
                  <p class="new-btns">{{topic.title}}</p>
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <b-row class="justify-content-md-center boxes claim ">
              <b-col :md="singleColumnButtons ? 6 : 10" :lg="singleColumnButtons ? 6 : 8" xl="12" :class="{'my-class': session && session.is_legacy}">
                <b-row class="choice-fields-btns">
                  <b-col :class="{'no-icon-faq-btn': !singleColumnButtons}" v-for="topic in topics" :key="'topic-' + topic.id" :md="singleColumnButtons ? 12 : 6">
                    <b-button block
                              @click="selectTopic(topic.id)"
                              class="btn btn-default btn-session faq_btn update-info"
                              variant="primary"
                    ><div class="no-icon-topic-title">{{topic.title}}</div></b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
        <section class="boxes update-back-btn">
          <b-row class="justify-content-md-center">
            <b-col v-if="!isRootTopic || (session && session.can_undo)" md="6">
              <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
            </b-col>
          </b-row>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {InputType} from '../constants'
import Breadcrumbs from '@/components/Breadcrumbs'
import {stopMouseflowRecording} from '@/utils'

const SessionContent = () => import('./SessionContent')
const FaqSearchBox = () => import('@/components/FaqSearchBox')

export default {
  name: 'FaqTopics',
  components: {
    Breadcrumbs,
    FaqSearchBox,
    SessionContent
  },
  data: function() {
    return {
      topics: [],
      topicChildren: {},
      faqTopicsMap: {}
    }
  },
  computed: {
    isIconButtons: function() {
      for (let i = 0; i < this.topics.length; i++) {
        if (!this.topics[i].icon) {
          return false
        }
      }
      return true
    },
    singleColumnButtons: function() {
      return this.topics.length < 6
    },
    isRootTopic: function() {
      return this.session && this.selectedTopicId === this.session.faq_root_topic
    },
    ...mapState(['session', 'allFaqTopics', 'faqsLoading', 'votedFaqs', 'isIE', 'previouslySelectedFaqTopic'])
  },
  methods: {
    initFaqs: function(delay = 0) {
      let self = this

      setTimeout(function() {
        if (!self.session) { // If user directly lands on this page, then create session first
          self.$store.dispatch('start')
            .then(_response => {
              self.$store.dispatch('jump', {step: 'faqs'})
                .then(session => {
                  console.log('Jumped to step faqs')
                  session.can_undo = true
                  self.initFaqs(100)
                })
                .catch(err => {
                  console.log(err)
                  self.$store.commit('critical_error', err)
                })
            })
        } else if (self.session.step_type !== InputType.Faqs) {
          self.$store.dispatch('jump', {step: 'faqs'})
            .then(session => {
              session.can_undo = true
              console.log('Jumped to step faqs')
            })
            .catch(err => {
              console.log(err)
              self.$store.commit('critical_error', err)
            })
        }
        if (self.faqsLoading) {
          self.initFaqs(500) // faq topics are still loading, so wait a little and then check again
        } else if (self.session) {
          self.allFaqTopics.forEach(faqTopic => {
            // group the faq topics by parent
            let parentId = faqTopic.parent

            if (!(parentId in self.topicChildren)) {
              self.topicChildren[parentId] = []
            }

            self.topicChildren[parentId].push(faqTopic)

            // map each faq topic by id
            self.faqTopicsMap[faqTopic.id] = faqTopic
          })
          self.selectTopic(self.session.faq_root_topic) // start at the root topic
          self.$store.commit('ready')
        }
      }, delay)
    },
    selectTopic: function(topicId) {
      if (!topicId) {
        topicId = this.previouslySelectedFaqTopic
      }
      this.selectedTopicId = topicId
      this.faqs = []
      this.$store.commit('update_selected_faq_topic', topicId)
      this.$store.dispatch('set_session_started')
      this.topics = (topicId in this.topicChildren) ? this.topicChildren[topicId] : []
      if (this.topics.length === 0) {
        this.$router.push({name: 'faqs'})
      }
    },
    goBack: function() {
      this.$store.commit('busy')
      this.$store.dispatch('undo')
        .then(session => {
          this.$store.commit('clear_messages')
          this.$store.commit('increment_undo_count')
          this.$router.replace({name: 'session'})
        })
        .catch(err => {
          console.log(err)
          if (!err.response || err.response.status !== 422) {
            this.$store.commit('critical_error', err)
          }
        })
    }
  },
  created() {
    this.initFaqs()
    stopMouseflowRecording()
  }
}
</script>

<style scoped lang="less">
  .no-icon-faq-btn {
    margin-top: 0; // Base style for mobile devices
  }

  @media only screen and (min-width: 768px) {
    .no-icon-faq-btn {
      margin-top: 10px; // Styles for screens with a minimum width of 768px
    }
  }
</style>
